<template>
  <div :class="getClass('card')" v-touch:tap="handleTap('tap')">
    <div :class="getClass('card__head')">
      <p>
        <img class="icon" :src="img" alt />
        日期：{{ formatTime(startTime) }} {{ getTime(startTime) }} -
        {{ getTime(endTime) }}
      </p>
    </div>
    <div :class="[bgColor]">
      <div :class="[getClass('card__content')]">
        <p class="content">
          {{ name }}
          <span style="color: #2ca9aa">X{{ countNum }}</span>
        </p>
        <p class="other price">{{ isCharge ? price : "免费" }}</p>
        <!-- <p class="reservation description">
          预约数:
          <span>{{}}</span>
        </p>-->
      </div>
      <template v-if="codeStatus.QRCode || codeStatus.des">
        <div
          style="
            width: calc(100% - 32px);
            margin: 0 auto;
            height: 0.5px;
            border-bottom: 0.5px solid #ebedf0;
          "
        ></div>
        <div :class="[getClass('card__footer')]">
          <div>
            <span class="status" :style="{ color: codeStatus.color }">{{
              codeStatus.des
            }}</span>
            <!-- <p class="cancel">已取消</p> -->
            <template v-if="codeStatus.operating">
              <span
                class="description"
                v-if="codeStatus.operating === 'cancel'"
                v-touch:tap.stop="handleTap('cancel')"
                >取消预约</span
              >
              <span
                class="description"
                v-if="codeStatus.operating === 'delete'"
                v-touch:tap.stop="handleTap('delete')"
                >删除</span
              >
            </template>
          </div>
          <!-- <div
            class="qr-code"
            v-if="codeStatus.QRCode"
            v-touch:tap.stop="handleTap('check')"
          >
            <p><i class="iconhebei iconerweima"></i>电子二维码</p>
          </div> -->
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import util from "@util";
import mobile from "@lib/image/personalCenter/mobile.png";
import pc from "@lib/image/personalCenter/pc.png";
import mobile_tuan from "@lib/image/personalCenter/mobile_tuan.png";
import mobile_san from "@lib/image/personalCenter/mobile_san.png";
import pc_tuan from "@lib/image/personalCenter/pc_tuan.png";
import pc_san from "@lib/image/personalCenter/pc_san.png";

export default {
  name: "OrderListCard",
  props: {
    id: {
      type: String,
      required: false,
    },

    name: {
      type: String,
      required: false,
    },
    startTime: {
      type: Number,
      required: false,
    },
    endTime: {
      type: Number,
      required: false,
    },
    countNum: {
      type: [String, Number],
      required: false,
    },
    status: {
      type: [Number, String],
      required: false,
      default: "3",
    },
    price: {
      type: [Number, String],
      required: false,
    },

    //报名
    type: {
      type: String,
      required: false,
      default: "signup",
    },

    //客人类型 门票才有   1：散客，2：团队  3：其它
    guestType: {
      type: String,
      required: false,
      default: "",
    },
    //渠道
    channel: {
      type: [String, Number],
      required: false,
      default: "",
    },

    //是否免费门票 0免费，1收费
    charge: {
      type: [String, Number],
      required: false,
      default: "",
    },
  },
  computed: {
    isCharge() {
      return this.charge != "0" ? true : false;
    },
    codeStatus() {
      let state = this.$store.state;
      let config =
        this.type === "signup"
          ? state["signupOrderListStatusCode"]
          : state["ticketOrderListStatusCode"];
      return config[this.status];
    },
    isPc() {
      //0：窗口售票1：微信售票2：pc官网
      return this.channel !== "2";
    },
    isGroupGuest() {
      //（0：散客，1：团队  2：其它）
      return this.guestType === "1";
    },
    img() {
      let img = "";
      if (this.type === "signup") {
        img = this.isPc ? pc : mobile;
        return img;
      } else if (this.isPc) {
        img = this.isGroupGuest ? pc_tuan : pc_san;
      } else {
        img = this.isGroupGuest ? mobile_tuan : mobile_san;
      }
      return img;
    },
    bgColor() {
      return this.isGroupGuest ? "yello" : "green";
    },
  },
  data() {
    return {};
  },
  methods: {
    formatTime(time) {
      return util.formatTime(new Date(time), "yyyy-MM-dd");
    },
    getTime(item) {
      return util.getTime(item);
    },
    handleTap(type) {
      return () => {
        this.$emit(type, this.id);
      };
    },
    getClass(name) {
      const PREFIX = "order-list-";
      return `${PREFIX}${name}`;
    },
  },
};
</script>

<style lang="less" scoped>
.order-list {
  &-card {
    // padding: 0 12px 0 18px;
    background: #ffffff;
    color: #606060;
    font-size: 12px;
    .iconhebei {
      transform: translateY(2px);
      display: inline-block;
    }
    .description {
      color: #b3b3b3 !important;
    }
    &__head {
      height: 46px;
      line-height: 46px;
      padding: 0 20px;
      // border-bottom: 0.5px solid #ebedf0;
      .icon {
        // width: 16px;
        height: 18px;
        margin-right: 6px;
        transform: translateY(-1px);
      }
    }
    &__content {
      height: ~"calc(100% - 50px - 54px)";
      font-size: 14px;
      padding: 14px 22px;
      // border-bottom: 0.5px solid #ebedf0;
      box-sizing: border-box;
      display: flex;
      justify-content: space-between;
      .content {
        color: #666666;
      }
      // .other {

      .price {
        margin-bottom: 8px;
        text-align: right;
        color: #ff8d09;
      }
      // .reservation {
      //   font-size: 12px;
      //   margin: 0 6px;
      //   span {
      //     width: 20px;
      //     display: inline-block;
      //   }
      // }
      // }
    }
    &__footer {
      height: 54px;
      padding: 0 20px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      font-size: 12px;
      .status {
        margin-right: 26px;
        &.success {
          color: #27af2d;
        }
        &.cancel {
          color: #7a7a7a;
        }
      }
      .qr-code {
        color: #606060;
        .iconhebei {
          margin-right: 10px;
          transform: translateY(2px);
        }
      }
    }

    .green {
      background: #eef9fa;
    }
    .yello {
      background: #fef9f3;
    }
  }
}
</style>
